var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#848484;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,2c-1.8,1.8-1.8,7.5,0,9.2c1.3,1,3,1.4,4.6,1.3c1.6,0.1,3.3-0.4,4.6-1.3C13,9.5,13,3.7,11.2,2S3.8,0.2,2,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,15.7c-1.8,1.8-1.8,7.5,0,9.2c1.3,1,3,1.4,4.6,1.3c1.6,0.1,3.3-0.4,4.6-1.3c1.8-1.8,1.8-7.5,0-9.2 C9.5,14,3.8,14,2,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,12.5c1.6,0.1,3.3-0.4,4.6-1.3c1.8-1.8,1.8-7.5,0-9.2c-1.8-1.7-7.5-1.8-9.2,0s-1.8,7.5,0,9.2 C17.1,12.2,18.7,12.7,20.4,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,15.7c-1.8,1.8-1.8,7.5,0,9.2c1.3,1,3,1.4,4.6,1.3c1.6,0.1,3.3-0.4,4.6-1.3c1.8-1.8,1.8-7.5,0-9.2 C23.2,14,17.5,14,15.8,15.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.b5868a9f264740757d599686227d6504.svg";
export { ForwardRef as ReactComponent };